import React from 'react';
import 'config/pdfWorker';
import {
  Auth0Provider,
} from '@auth0/auth0-react';
import {
  ThemeProvider,
} from '@mui/material/styles';
import auth0ProviderConfig from 'config/auth';
import theme from 'config/mui';
import 'config/mixpanel';
import ErrorBoundary from 'pages/Dashboard/components/ErrorBoundary';
import AuthSessionSync from 'core/components/AuthSessionSync';
import ReactQueryProvider from 'core/components/ReactQueryProvider';
import {
  RouterProvider,
} from 'react-router-dom';
import router from 'views/EMR/router';
import {
  SnackbarProvider,
} from 'notistack';
import Notification from 'core/components/Notification';
import {
  useGoogleMaps,
} from 'core/hooks';
import 'config/datadogBrowserLogs';
import {
  ImpersonationProvider,
} from 'core/context/impersonation';
import 'utils/dayjs';

export default function EMRApp() {
  useGoogleMaps();
  return (
    <ErrorBoundary>
      <Auth0Provider {...auth0ProviderConfig}>
        <SnackbarProvider Components={{ custom: Notification }}>
          <AuthSessionSync />
          <ImpersonationProvider>
            <ReactQueryProvider>
              <ThemeProvider theme={theme}>
                <div className="h-full w-full">
                  <RouterProvider router={router} />
                </div>
              </ThemeProvider>
            </ReactQueryProvider>
          </ImpersonationProvider>
        </SnackbarProvider>
      </Auth0Provider>
    </ErrorBoundary>
  );
}
